<template>
  <div class="classmate-homework-wrap">
    <p class="cont-title">
      <span>同学作业</span>
      <span v-if="total > 0">({{ total }})</span>
    </p>
    <div v-if="dataList?.length">
      <answer-info
        v-for="item in dataList"
        :key="item.user_work_id"
        :info="item"
      />
    </div>
    <!-- 空状态 -->
    <div v-else class="empty">
      <img src="../../../assets/images/chat/file-empty.png" alt="" />
      <p class="text">暂无作业</p>
    </div>
  </div>
</template>

<script>
import AnswerInfo from "@saas/pages/src/homework-custom/components/AnswerInfo.vue";
import { getStudentWork } from "@saas/service-api/src/homework/index";
export default {
  data() {
    return {
      work_id: null,
      dataList: [],
      page_no: 1,
      page_size: 10,
      total: 0,
      loading: false,
    };
  },
  components: {
    AnswerInfo,
  },
  mounted() {
    this.work_id = this.$route.params.id;
    this.apiGetStudentWork();
    this.$nextTick(() => {
      if (window.isElectron) {
        let elMain = document.getElementById("electron-main");
        if (!elMain) return;
        elMain.addEventListener("scroll", this.handleElScrollFn, true);
      } else {
        window.addEventListener("scroll", this.scrollFn, true); //监听页面滚动
      }
    });
  },
  beforeDestroy() {
    if (window.isElectron) {
      let elMain = document.getElementById("electron-main");
      if (!elMain) return;
      elMain.removeEventListener("scroll", this.handleElScrollFn, true);
    } else {
      window.removeEventListener("scroll", this.scrollFn, true); //销毁滚动事件
    }
  },
  methods: {
    handleElScrollFn(event) {
      if (this.total === this.dataList?.length || this.loading) return;
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 触底-加载下一页
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        this.page_no++;
        this.apiGetStudentWork();
      }
    },
    scrollFn() {
      if (this.total === this.dataList?.length || this.loading) return;
      false;
      //获取网页的总高度
      var htmlHeight =
        document.body.scrollHeight || document.documentElement.scrollHeight;
      //clientHeight是网页在浏览器中的可视高度
      var clientHeight =
        document.body.clientHeight || document.documentElement.clientHeight;
      //scrollTop是浏览器滚动条的top位置
      var scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      //判断到底部了
      if (scrollTop + clientHeight > htmlHeight - 100) {
        this.page_no++;
        this.apiGetStudentWork();
      }
    },
    apiGetStudentWork() {
      this.loading = true;
      getStudentWork({
        work_id: this.work_id,
        page_no: this.page_no,
        page_size: this.page_size,
      })
        .then((res) => {
          if (res.code === 1) {
            if (this.page_no === 1) {
              this.dataList = res?.data?.list || [];
            } else {
              this.dataList = this.dataList.concat(res?.data?.list || []);
            }
            this.total = res?.data?.total || 0;
          } else {
            this.$message.error(res.message);
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.classmate-homework-wrap {
  min-height: 240px;
  border-radius: 16px;
  border: 1px solid #f2f3f5;
  margin-top: 16px;
  .cont-title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
    color: #0d1400;
    line-height: 22px;
    height: 46px;
    background: #f7f8fa;
    border-radius: 16px 16px 0px 0px;
    border: 1px solid #f2f3f5;
    padding-left: 16px;
  }
  .empty {
    padding-top: 30px;
    img {
      width: 100px;
      height: 100px;
      margin: 0 auto;
    }
    margin-bottom: 12px;
    font-weight: 400;
    font-size: 14px;
    color: #0d1400;
    line-height: 16px;
    text-align: center;
  }
  .answer-info-wrap {
    border-bottom: 1px solid #f2f3f5;
    &:last-child {
      border-bottom: none;
    }
  }
}
</style>
